import { captureException } from "@sentry/browser";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { v4 as uuidv4 } from "uuid";
import { getStepIndex } from "../../helpers/steps";
// eslint-disable-next-line import/no-cycle
import { ApplicationApi } from "../../server/agent";
import { AuthActionCreators } from "../action-creators";
import { StepsActionCreators } from "../action-creators/stepsActions";
import {
  selectAnonymousId,
  selectApplicationId,
  selectIsAuth,
  selectIsFirstApplication,
} from "../selectors";

const ignoredSteps = [
  "/new_application-number-confirmation",
  "/reapplication-number-confirmation",
  "/new_application-timer",
];

const isNewUrls = {
  true: ["/registration", "/registration-number-confirmation"],
  false: ["/authorization", "/authorization-number-confirmation"],
};

function* updateAnonymousLastStepOnServer(stepUrl) {
  let id = yield select(selectAnonymousId);
  if (!id) {
    id = uuidv4();
    yield put(AuthActionCreators.setAnononymousId(id));
  }

  let step = null;
  let isNew = null;

  if (isNewUrls.true.includes(stepUrl)) {
    step = isNewUrls.true.indexOf(stepUrl);
    isNew = true;
  }

  if (isNewUrls.false.includes(stepUrl)) {
    step = isNewUrls.false.indexOf(stepUrl);
    isNew = false;
  }

  // Игнорим url не присутствующие в isNewUrls
  if (isNew === null) return;

  yield call(ApplicationApi.setAnonymousStep, { id, step, isNew });
}

function* updateAuthorizedLastStepOnServer(stepUrl) {
  const applicationId = yield select(selectApplicationId);
  const isFirstApplication = yield select(selectIsFirstApplication);

  const step = parseInt(getStepIndex(stepUrl), 10);

  yield call(ApplicationApi.setLastStep, {
    applicationId,
    step,
    isNew: isFirstApplication,
  });
}

function* updateLastStepOnServer(action) {
  const stepUrl = action.payload;
  if (ignoredSteps.indexOf(stepUrl) > -1) return;

  try {
    const isAuth = yield select(selectIsAuth);
    if (isAuth) {
      yield updateAuthorizedLastStepOnServer(stepUrl);
    } else {
      yield updateAnonymousLastStepOnServer(stepUrl);
    }
  } catch (e) {
    captureException(e, "Ошибка обновления шага анкеты");
  }
}

function* updateLastStepSaga() {
  const setLastStepType = StepsActionCreators.setLastStep(null).type;
  yield takeLatest(setLastStepType, updateLastStepOnServer);
}

// eslint-disable-next-line import/no-default-export
export default updateLastStepSaga;
